const ToggleSubmenu = () => {

document.addEventListener('DOMContentLoaded', function () {
    var buttons = document.querySelectorAll('.header__arrow-wrap');

    function toggleSubmenu(btn, forceOpen) {
        var li = btn.closest('.header__item');
        var submenuId = btn.getAttribute('aria-controls');
        var submenu = submenuId ? document.getElementById(submenuId) : null;
        if (!li || !submenu) return;

        var expanded = btn.getAttribute('aria-expanded') === 'true';
        var willOpen = (typeof forceOpen === 'boolean') ? forceOpen : !expanded;

        btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        li.classList.toggle('is-open', willOpen);
        if (willOpen) submenu.removeAttribute('hidden'); else submenu.setAttribute('hidden', '');
    }

    buttons.forEach(function (btn) {
        btn.addEventListener('click', function () { toggleSubmenu(btn); });
        btn.addEventListener('keydown', function (e) {
            var k = e.key || e.code;
            if (k === 'Enter' || k === ' ' || k === 'Spacebar') { e.preventDefault(); toggleSubmenu(btn); }
            if (k === 'Escape' || k === 'Esc') { e.preventDefault(); toggleSubmenu(btn, false); btn.focus(); }
        });
    });
});

}

export default ToggleSubmenu